import React, { useEffect } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import {
  postModHelperTemplate,
  editModHelperTemplate,
  getModHelperType,
} from "../../../_redux/actions/ActionSettings";
import { connect } from "react-redux";

const AddHelper = ({
  postModHelperTemplate,
  getModHelperType,
  editModHelperTemplate,
  helperType,
  helperData,
  setHelperData,
  setShowAdd,
}) => {
  const { register, handleSubmit } = useForm({
    mode: "onBlur",
    defaultValues: {},
  });

  const onSubmit = (data) => {
    helperData
      ? editModHelperTemplate(data, helperData.id)
      : postModHelperTemplate(data);
    setHelperData(null);
    setShowAdd(false);
  };
  useEffect(() => {
    getModHelperType();
  }, [getModHelperType]);

  return (
    <Card>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col md={4}>
              <Form.Group controlId="formGroupName">
                <Form.Label>Template Type</Form.Label>
                <Form.Control
                  as="select"
                  {...register("category")}
                  defaultValue={helperData && helperData.category}
                >
                  {helperType.length > 0 &&
                    helperType.map((item, index) => (
                      <option value={item.id}>
                        {helperData ? helperData.category_title : item.category}
                      </option>
                    ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={8}>
              <Form.Group controlId="formGroupName">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  {...register("helper_text")}
                  defaultValue={helperData && helperData.helper_text}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={2}>
              <Button className="btn-primary btn-round btn-sm" type="submit">
                {helperData ? "Edit" : "Send"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  helperType: state.moderatorHelper.helperType,
});

const mapDispatchToProps = {
  postModHelperTemplate,
  getModHelperType,
  editModHelperTemplate,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddHelper);
